import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { Image, theme } from "antd"

import { LOCAL_STORAGE, THEME_MODE } from "../../../data/configs/constants"
import { IMG_LOGO_DARK, IMG_LOGO_LIGHT } from "../../../data/assets"
import { getDataFromLocalStorage } from "../../../data/utils"

const SpinnerLoader = ({ brand, size, ...restProps }) => {
  const {token} = theme.useToken()

  const themeMode = useSelector((state) => state.pageDetails.themeMode)
  const domainConfig = getDataFromLocalStorage(LOCAL_STORAGE.DOMAIN_CONFIG)

  return(
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      ...restProps
    }}>

      {brand && process.env.REACT_APP_WHITE_LABELED_APP !=='true' ? (
        <Image
          className="od-animated od-pulse"
          src={themeMode === THEME_MODE.DARK ? IMG_LOGO_DARK : IMG_LOGO_LIGHT}
          alt="Logo"
          width={size}
        />
      ) : domainConfig?.branding?.logoUrlSmall ? (
        <Image
          className="od-animated od-pulse"
          src={domainConfig?.branding?.logoUrlSmall}
          alt="Logo"
          width={size}
        />
      ) : (
        <svg
          color={token.colorFillSecondary}
          width={24}
          height={24}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <style
            dangerouslySetInnerHTML={{
              __html:
                ".spinner_ajPY{transform-origin:center;animation:spinner_AtaB .75s infinite linear}@keyframes spinner_AtaB{100%{transform:rotate(360deg)}}"
            }}
          />
          <path
            d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
            opacity=".25"
          />
          <path
            d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
            className="spinner_ajPY"
          />
        </svg>

      )}

    </div>
  )
}

SpinnerLoader.propTypes = {
  brand: PropTypes.bool,
  size: PropTypes.number,
}

SpinnerLoader.defaultProps = {
  brand: false,
  size: 60,
}

export default SpinnerLoader
